import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    // locale code like 'en-US', 'es-MX', or null if none is specified.
    localeCode: null,
};
var localeSlice = createSlice({
    name: 'locales',
    initialState: initialState,
    reducers: {
        setLocaleCode: function (state, action) {
            state.localeCode = action.payload;
        },
    },
});
export var setLocaleCode = localeSlice.actions.setLocaleCode;
export default localeSlice.reducer;
